export const FORCE_LOGIN_COMPANY = 'forceLogin';

export const getStoredCompany = (company?: string | null) => {
  if (!company || company === FORCE_LOGIN_COMPANY) {
    return '';
  }

  return company;
};

export const getDashboardCrmTargetPath = (company?: string | null) => {
  const storedCompany = getStoredCompany(company);

  return storedCompany ? `/${storedCompany}` : `/${FORCE_LOGIN_COMPANY}`;
};

export const getPathSegments = (pathname: string) =>
  pathname.split('/').filter(Boolean);
